import { useEffect, useRef, useState } from 'react';
import { useAccount } from 'wagmi';

export default function useIsEvmAccountInitialized() {
  const account = useAccount();
  const [initialized, setInitialized] = useState(false);
  const accountStatusRef = useRef(account.status);

  useEffect(() => {
    if (initialized) return;

    if (accountStatusRef.current === 'connecting' && account.status !== 'connecting') {
      setInitialized(true);
    }

    accountStatusRef.current = account.status;
  }, [account.status]);

  return initialized;
}
